import { render } from "./NeiOrderDetail.vue?vue&type=template&id=1fc7d79b&scoped=true"
import script from "./NeiOrderDetail.vue?vue&type=script&lang=ts"
export * from "./NeiOrderDetail.vue?vue&type=script&lang=ts"

import "./NeiOrderDetail.vue?vue&type=style&index=0&id=1fc7d79b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1fc7d79b"

export default script